import { useEffect, useState } from "react";

import PlaylistAddOutlinedIcon from "@mui/icons-material/PlaylistAddOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export default function SavePlaylistDialog(props) {
    const [text, setText] = useState("");
    const [includeNotes, setIncludeNotes] = useState(true);

    useEffect(() => {
        if (props.initialValue) {
            setText(props.initialValue);
        }
    }, [props.initialValue]);

    function handleCancelClick() {
        props.onClose(text, false, includeNotes);
        setText(props.initialValue || "");
    }

    function handleOKClick() {
        props.onClose(text, true, includeNotes);
        setText("");
    }

    return (
        <Dialog
            onClose={handleCancelClick}
            open={props.open}
            fullWidth
            maxWidth="sm"
            aria-labelledby="save-playlist-dialog-title"
            slotProps={{
                paper: {
                    sx: { borderRadius: 3, overflow: "hidden" },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "primary.main",
                        backgroundColor: "rgba(0, 149, 61, 0.09)",
                    }}
                >
                    <PlaylistAddOutlinedIcon />
                </Box>
                <Box>
                    <Typography
                        id="save-playlist-dialog-title"
                        variant="h5"
                        component="h2"
                        sx={{ lineHeight: 1.15 }}
                    >
                        {props.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                    >
                        {props.message}
                    </Typography>
                </Box>
            </Box>

            <DialogContent
                dividers
                sx={{
                    p: { xs: 2, sm: 3 },
                    backgroundColor: "background.default",
                }}
            >
                <Box
                    sx={{
                        p: { xs: 2, sm: 2.5 },
                        borderRadius: 2.5,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                    }}
                >
                    <TextField
                        value={text}
                        onChange={(event) => setText(event.target.value)}
                        autoFocus
                        id="playlist-name"
                        label="Playlist name"
                        fullWidth
                        sx={{
                            "& .MuiOutlinedInput-root": { borderRadius: 2 },
                        }}
                    />
                    <FormControlLabel
                        sx={{ mt: 1.25 }}
                        control={
                            <Checkbox
                                checked={includeNotes}
                                onChange={() =>
                                    setIncludeNotes(!includeNotes)
                                }
                                name="include-notes"
                                color="primary"
                            />
                        }
                        label="Include clip notes"
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
                <Button onClick={handleCancelClick} color="inherit">
                    Cancel
                </Button>
                <Button
                    onClick={handleOKClick}
                    variant="contained"
                    disableElevation
                >
                    Create playlist
                </Button>
            </DialogActions>
        </Dialog>
    );
}
